<template>
    <div class="contract-manage-iflow-table">
        <table-box v-loading="subTabTable.tableLoading" :selection="TABLECONFIG.selection" ref="histroryRef"
            :columns="TABLECONFIG.columns" :height="tableHeight" :actions="TABLECONFIG.actions"
            :rows="subTabTable.totalData" @action-click="actionClick">
            <template #col-header="{ col }">
                <span v-if="['oldValue', 'newValue', 'oldValueName', 'newValueName'].includes(col.prop)" class="slot-box">
                    <span>{{ col.label }}</span>
                    <img class="text-eyes"
                        :src="getFieldVisible(col.prop) ? iconOpenEyes : iconCloseEyes" alt=""
                        @click.stop="toggleGlobalPassword(col.prop)" />
                </span>
                <span v-else>{{ col.label }}</span>
            </template>
            <template #col-append="{ col, row, rIndex }">
                <span v-if="['newValueName','newValue','oldValueName','oldValue'].includes(col.prop)">
                    <template v-if="row.updateFieldCode==='id_number'">
                        <span :title="row[col.prop]">{{ encryptionHandle(row[col.prop] || '', col.prop,row.id) }}</span>
                        <img v-if="row[col.prop] && encryptionHandle(row[col.prop], col.prop,row.id)" :class="['text-eyes']" @click.stop="handleChangeText(col,row)"
                            :src="encryption[col.prop+row.id] ? iconOpenEyes : iconCloseEyes" alt="">
                    </template>
                    <template v-else-if="row[col.prop] && ['accountPassword', 'registrantPhone', 'websiteAccount'].includes(row.updateFieldCode)">
                        <span class="password-cell">
                            <span class="password-text" :title="getRowPasswordShow(row, col.prop) ? row[col.prop] : ''">
                                {{ getRowPasswordShow(row, col.prop) ? row[col.prop] : getMaskValue(row, col.prop) }}
                            </span>
                            <img class="row-eyes" :src="getRowPasswordShow(row, col.prop) ? iconOpenEyes : iconCloseEyes" alt="" @click.stop="toggleRowPassword(row, col.prop)" />
                        </span>
                    </template>
                    <span v-else :title="row[col.prop]">{{ row[col.prop] }}</span>
                </span>
                <span v-else>{{ row[col.prop] }}</span>
            </template>
        </table-box>
        <div class="footer">
            <lots-pagination @size-change='subTabTable.sizeChange' :current-page.sync='subTabTable.pageNo'
                @current-change='subTabTable.pageChange' size="small" layout='total, sizes, prev, pager, next, jumper'
                :total='subTabTable.pageTotal' />
        </div>
    </div>
</template>

<script>
import lotsPagination from '@/components/lots/lotsPagination/Index';
import { AdvanceListClass } from '@/modules/mdm/composition/dc/common/list/AdvanceListClass';
import { getBiddingAccountRecordApi } from '@mdm/api/customer/biddingAccountManage.js';
import { computed, reactive, toRefs, ref } from '@vue/composition-api';
import { tableConfig } from './config.js';
import tableBox from '@/components/lots/tableBox/Index';
import otherUtils from '@/modules/mdm/utils/otherCommonFunc.js';
import iconOpenEyes from '@/assets/images/icon-open-eyes.png';
import iconCloseEyes from '@/assets/images/icon-close-eyes.png';
import _ from 'lodash';
export default {
    components: {
        lotsPagination, tableBox
    },
    props: {
        detailData: {
            type: Object,
            return: () => { }
        },
        tableHeight: {
            type: Number,
            default: 357
        },
        actions: { // 表格操作信息，不传默认为空
            type: Object,
            default() {
                return {
                    list: []
                };
            }
        }
    },
    /* eslint-disable max-lines-per-function */
    setup(props, setupContext) {
        const config = reactive(tableConfig);
        // eslint-disable-next-line complexity
        const TABLECONFIG = computed(() => {
            return config;
        });
        const convertEmptyStringsToNull = (obj) => {
            return _.mapValues(obj, value => {
                if (typeof value === 'string') {
                    return _.trim(value) === '' ? null : value;
                }
                return value;
            });
        };
        const maskAccount = (account) => {
            if (!account || account.length <= 4) return account;
            return account.substring(0, 2) + '***' + account.substring(account.length - 2);
        };

        class IhistoryTalbeClass extends AdvanceListClass {
            beforeGetList(condition) {
                condition.relationId = props.detailData.id;
                condition.orderBy = 'create_time';
                condition.orderByType = 'desc';
                condition = convertEmptyStringsToNull(condition);
                return condition;
            }
            afterGetList(res) {
                if (+res.code === 0 && res.data && res.data.list) {
                    subTabTable.totalData.value = res.data.list.map(item => {
                        item.rowVisible_oldValue = false;
                        item.rowVisible_newValue = false;
                        item.rowVisible_oldValueName = false;
                        item.rowVisible_newValueName = false;
                        return item;
                    }) || [];
                    subTabTable.pageTotal.value = res.data.totalCount || 0;
                }
                globalVisibleMap.oldValue.value = false;
                globalVisibleMap.newValue.value = false;
                globalVisibleMap.oldValueName.value = false;
                globalVisibleMap.newValueName.value = false;
            }
        };
        const subTabTable = new IhistoryTalbeClass({
            Api: {
                listApi: getBiddingAccountRecordApi
            }
        });

        const state = reactive({
            searchHeaderParams: {}
        });

        const actionClick = (event, row) => { };
        const encryption = ref({
            idNumber: false
        });
        const encryptionKey = ref(1);
        const handleChangeText = (item, row) => {
            encryption.value[item.prop + row.id] = !encryption.value[item.prop + row.id];
            encryptionKey.value++;
        };
        // 对应加密方法
        const menuList = {
            newValueName: 'idCard',
            newValue: 'idCard',
            oldValueName: 'idCard',
            oldValue: 'idCard'
        };
        const encryptionHandle = (val, p, id) => {
            const { desensitization } = otherUtils;
            const prop = menuList[p];
            if (!desensitization[prop]) return '';
            if (encryption.value[p + id]) return val;
            return desensitization[prop](val);
        };
        const globalVisibleMap = {
            oldValue: ref(false),
            newValue: ref(false),
            oldValueName: ref(false),
            newValueName: ref(false)
        };
        const getFieldVisible = (colProp) => {
            if (!colProp) return false;
            const fieldMap = globalVisibleMap[colProp];
            return fieldMap && fieldMap.value;
        };
        const toggleGlobalPassword = (colProp) => {
            if (!colProp) return;
            const current = getFieldVisible(colProp);
            globalVisibleMap[colProp].value = !current;
            if (!current) {
                const key = `rowVisible_${colProp}`;
                subTabTable.totalData.value.forEach(row => {
                    row[key] = true;
                });
            }
        };
        const getRowPasswordShow = (row, colProp) => {
            if (!colProp || !globalVisibleMap[colProp]) return false;
            const key = `rowVisible_${colProp}`;
            return getFieldVisible(colProp) && row[key];
        };
        const getMaskValue = (row, colProp) => {
            const fieldCode = row.updateFieldCode;
            const value = row[colProp];
            if (fieldCode === 'accountPassword') return '********';
            if (fieldCode === 'registrantPhone') return otherUtils.desensitization.phone(value) || '********';
            if (fieldCode === 'websiteAccount') return maskAccount(value) || '********';
            return '********';
        };
        const toggleRowPassword = (row, colProp) => {
            if (!colProp || !globalVisibleMap[colProp]) return;
            const globalVisible = getFieldVisible(colProp);
            const key = `rowVisible_${colProp}`;
            if (!globalVisible) {
                globalVisibleMap[colProp].value = true;
                subTabTable.totalData.value.forEach(rowItem => {
                    rowItem[key] = (rowItem === row);
                });
            } else {
                row[key] = !row[key];
            }
        };
        const getHistoryList = () => {
            subTabTable.getList();
        };
        return {
            ...toRefs(state),
            getHistoryList,
            config,
            TABLECONFIG,
            subTabTable,
            actionClick,
            iconCloseEyes,
            iconOpenEyes,
            encryption,
            encryptionKey,
            handleChangeText,
            encryptionHandle,
            globalVisibleMap,
            getFieldVisible,
            toggleGlobalPassword,
            getRowPasswordShow,
            getMaskValue,
            toggleRowPassword
        };
    }
};
</script>
<style lang='less'>
.contract-manage-iflow-table {

    // margin-top: 15px;
    .footer {
        padding: 10px 0;
        display: flex;
        justify-content: flex-end;
        align-items: center;
    }

    .mip-page-link {
        color: #4285f5;
        cursor: pointer;

        &.no-wrap {
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
        }
    }

    .price-icon {
        font-size: 12px;
        cursor: pointer;
        color: #000;
    }

    .icon-active {
        color: #4285f5 !important;
    }

    .slot-box {
        display: flex;
        align-items: center;
        justify-content: space-between;
        cursor: pointer;
        width: 100%;

        .text-eyes {
            width: 14px;
            margin-left: 4px;
            cursor: pointer;
            flex-shrink: 0;
        }
    }

    .password-cell {
        display: flex;
        align-items: center;
        gap: 4px;

        .password-text {
            flex: 1;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        }

        .row-eyes {
            width: 14px;
            cursor: pointer;
            flex-shrink: 0;
        }
    }
}
</style>
